import PropTypes from "prop-types";

export const termProps = {
  id: PropTypes.number,
  categoryId: PropTypes.number,
  type: PropTypes.string,
  name: PropTypes.string,
  caseSensitive: PropTypes.bool,
  description: PropTypes.string,
  dictionaryTermType: PropTypes.number,
  colour: PropTypes.string,
  error: PropTypes.string,
};

export const categoryProps = {
  id: PropTypes.number,
  type: PropTypes.string,
  isExpanded: PropTypes.bool,
  name: PropTypes.string,
  description: PropTypes.string,
  terms: PropTypes.arrayOf(PropTypes.shape(termProps)),
  error: PropTypes.string,
};

export const entryProps = {
  id: PropTypes.number,
  categoryId: PropTypes.number,
  type: PropTypes.string,
  name: PropTypes.string,
  caseSensitive: PropTypes.bool,
  description: PropTypes.string,
  error: PropTypes.string,
  terms: PropTypes.arrayOf(PropTypes.shape(termProps)),
  dictionaryTermType: PropTypes.number,
  colour: PropTypes.string,
  isExpanded: PropTypes.bool,
};
